import request from '@/utils/request';

// 客户跟进提醒列表
export function customerfollowupnoticelist(data) {
  return request({
    url: '/customer-follow-up-notice/list',
    method: 'post',
    data
  });
}

// 添加客户跟进提醒
export function customerfollowupnoticecreate(data) {
  return request({
    url: '/customer-follow-up-notice/create',
    method: 'post',
    data
  });
}
